import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskProformaJiraFormBuilderRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-proforma-jira-form-builder',
	path: '/jira/servicedesk/projects/:projectKey/settings/forms/form/:templateFormId/edit',
	exact: true,
};
